export const gifIcons = ['/assets/gif/Helix-animation.gif', '/assets/gif/radar.gif', '/assets/gif/spinner40_full.gif'];
